export default "__VITE_ASSET__ogMVZyfR__"